import { ReactNode } from 'react';
import { makeStyles } from '@mui/styles';

type FooterActionProps = { children: ReactNode };

const FooterActions: React.FC<FooterActionProps> = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.container}>{children}</div>;
};

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'absolute',
    right: '5%',
    bottom: theme.constants.app.footerOffset,
    marginBottom: '1rem',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      right: '1.5%',
      flexDirection: 'column-reverse',
      alignItems: 'center',
    },
  },
}));

export default FooterActions;
